import Vue from 'vue'
import Router from 'vue-router'
//首页
import ScenicDateData from '@/pages/ScenicDateData'
import ScenicData from '@/pages/ScenicData'
import ScenicWarning from '@/pages/ScenicWarning'
import Login from '@/pages/login'
import store from '@/store'
//新首页

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/scenic_date_data',
      name: 'scenic_date_data',
      component: ScenicDateData,
      meta: {
        title: '篁岭大数据',
        router_name: 'scenic_date_data'
      }
    },
    {
      path: '/',
      name: 'scenic_data',
      component: ScenicData,
      meta: {
        title: '景区大数据中心',
        router_name: 'scenic_data'
      }
    },
    {
      path: '/scenic_warning',
      name: 'scenic_warning',
      component: ScenicWarning,
      meta: {
        title: '客流预警',
        router_name: 'scenic_warning'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '登录',
        router_name: 'login'
      }
    },
    ]
})
router.beforeEach((to,from,next)=>{
  let userInfo = sessionStorage.getItem('userInfo');
  let id = sessionStorage.getItem('scenicId');
  store.commit('setUserInfo',userInfo);
  store.commit('setScenicId',id);
  if(userInfo){
     next();
  }else{
      if (to.path === '/login') {
        next()
      } else {
        next('/login')
      }
  }
  
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js